import * as React from "react";
import {MouseEvent} from "react";
import {connect} from "react-redux";
import MyProfileBottomComponent from "../components/MyProfileBottomComponent";
import {
    getSpecialsSelector,
    getStylesSelector,
    likedStyleLoadSelector,
    loadingTabSelector,
    styleLoadSelector
} from "../selectors";
import {clearItems, fetchUserLikedStyles, fetchUserSpecials, fetchUserStyles} from "../middlewares";
import {specialsSelector, stylesSelector} from "../../_data/selectors";
import User from "../../_data/models/User";
import Meta from "../../_data/models/Meta";
import {createOrderedMapfromIDs} from "../../_helpers/utils";
import {ResourceType} from "../../_helpers/data";

interface Props {
    profile: User;
}

const mapStateToProps = (state, ownProps: Props) => {
    const sp = getSpecialsSelector(state);
    return {
        profile: ownProps.profile,
        loadingTab: loadingTabSelector(state),
        styleLoad: styleLoadSelector(state),
        likedStyleLoad: likedStyleLoadSelector(state),
        styles: {
            items: createOrderedMapfromIDs(getStylesSelector(state).ids, stylesSelector(state)),
            meta: getStylesSelector(state).meta
        },
        specials: {
            items: createOrderedMapfromIDs(sp.ids, specialsSelector(state)),
            meta: sp.meta,
            loading: sp.loading
        },
    }
};

const mapDispatchToProps = (dispatch, ownProps: Props) => {
    return {
        loadMore: (meta: Meta, resource: string, isLiked: boolean = null) => {
            if (meta && meta.hasNext()) {
                if (resource == ResourceType.special) {
                    dispatch(fetchUserSpecials(ownProps.profile.id, meta.nextPage));
                } else if (resource == ResourceType.style) {
                    if (!isLiked) {
                        dispatch(fetchUserStyles(ownProps.profile.id, meta.nextPage));
                    } else {
                        dispatch(fetchUserLikedStyles(ownProps.profile.id, meta.nextPage));
                    }
                }
            }
        },
        loadStyles: (id: number, e: MouseEvent<HTMLElement>) => {
            e.stopPropagation();
            e.preventDefault();
            dispatch(clearItems());
            dispatch(fetchUserStyles(id));
        },
        loadLikedStyles: (id: number, e: MouseEvent<HTMLElement>) => {
            e.stopPropagation();
            e.preventDefault();
            dispatch(clearItems());
            dispatch(fetchUserLikedStyles(id));
        },
        loadSpecials: (id: number, e: MouseEvent<HTMLElement>) => {
            e.stopPropagation();
            e.preventDefault();
            dispatch(clearItems());
            dispatch(fetchUserSpecials(id));
        }
    }
};

const MyProfileBottomContainer = connect(mapStateToProps, mapDispatchToProps)(MyProfileBottomComponent);
export default MyProfileBottomContainer;


// WEBPACK FOOTER //
// ./app/client/user/container/MyProfileBottomContainer.tsx